"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_DATASHEET_SUBSCRIPTIONS = exports.READ_DATASHEET_META = exports.GET_USER_LIST = exports.READ_EMBED_DATAPACK = exports.READ_TEMPLATE_DATAPACK = exports.READ_SHARE_DATAPACK = exports.READ_RECORDS = exports.DATAPACK = exports.READ_EMBED_FOREIGN_DATASHEET_PACK = exports.GET_RECORD_ACTIVITY_LIST = exports.READ_SHARE_FOREIGN_DATASHEET_PACK = exports.READ_FOREIGN_DATASHEET_VIEW_PACK = exports.READ_FOREIGN_DATASHEET_PACK = exports.READ_SHARE_CHANGESET = exports.READ_CHANGESET = exports.APPLY_RESOURCE_CHANGESETS = exports.GET_COMMENTS_BY_IDS = exports.NOTIFICATION_PATH = exports.ROOM_PATH = exports.WEBSOCKET_NAMESPACE = exports.READ_FORM_SUBMIT_STATUS = exports.READ_FORM_PROPS = exports.UPDATE_FORM_PROPS = exports.SHARE_FORM_ADD_RECORD = exports.FORM_ADD_RECORD = exports.READ_TEMPLATE_FORMPACK = exports.READ_SHARE_FORMPACK = exports.FORMPACK = exports.GET_SHARE_DST_VIEW_DATA_PACK = exports.GET_DST_VIEW_DATA_PACK = exports.UNSUBSCRIBE_MIRROR_RECORDS = exports.SUBSCRIBE_MIRROR_RECORDS = exports.GET_MIRROR_SUBSCRIPTIONS = exports.READ_SHARE_MIRROR_DATA_PACK = exports.READ_SHARE_MIRROR_INFO = exports.READ_MIRROR_DATA_PACK = exports.READ_MIRROR_INFO = exports.BATCH_DELETE_PERMISSION_ROLE = exports.BATCH_EDIT_PERMISSION_ROLE = exports.GET_FIELD_PERMISSION_MAP = exports.FIELD_PERMISSION_UPDATE_SETTING = exports.FIELD_PERMISSION_STATUS = exports.FIELD_PERMISSION_ROLE_LIST = exports.FIELD_PERMISSION_EDIT_ROLE = exports.FIELD_PERMISSION_DELETE_ROLE = exports.FIELD_PERMISSION_ADD_ROLE = exports.FETCH_EMBED_DASHBOARD = exports.FETCH_TEMPLATE_DASHBOARD = exports.FETCH_SHARE_DASHBOARD = exports.FETCH_DASHBOARD = void 0;
exports.UPDATE_CASCADER_SNAPSHOT = exports.CASCADER_SNAPSHOT = exports.CASCADER_DATA = exports.GET_CONTENT_DISPOSITION = exports.UNSUBSCRIBE_DATASHEET_RECORDS = exports.SUBSCRIBE_DATASHEET_RECORDS = void 0;
// =============== Dashboard related =======================
exports.FETCH_DASHBOARD = '/dashboard/:dashboardId/dataPack';
exports.FETCH_SHARE_DASHBOARD = '/share/:shareId/dashboard/:dashboardId/dataPck';
exports.FETCH_TEMPLATE_DASHBOARD = '/template/:templateId/dashboard/:dashboardId/dataPck';
exports.FETCH_EMBED_DASHBOARD = '/embedlinks/:embedId/dashboards/:dashboardId/dataPack';
// =============== Dashboard related =======================
// =============== Column permissions related start =======================
exports.FIELD_PERMISSION_ADD_ROLE = 'datasheet/:dstId/field/:fieldId/addRole';
exports.FIELD_PERMISSION_DELETE_ROLE = 'datasheet/:dstId/field/:fieldId/deleteRole';
exports.FIELD_PERMISSION_EDIT_ROLE = 'datasheet/:dstId/field/:fieldId/editRole';
exports.FIELD_PERMISSION_ROLE_LIST = 'datasheet/:dstId/field/:fieldId/listRole';
exports.FIELD_PERMISSION_STATUS = 'datasheet/:dstId/field/:fieldId/permission/:status';
exports.FIELD_PERMISSION_UPDATE_SETTING = 'datasheet/:dstId/field/:fieldId/updateRoleSetting';
exports.GET_FIELD_PERMISSION_MAP = 'datasheet/field/permission';
exports.BATCH_EDIT_PERMISSION_ROLE = 'datasheet/:dstId/field/:fieldId/batchEditRole';
exports.BATCH_DELETE_PERMISSION_ROLE = 'datasheet/:dstId/field/:fieldId/batchDeleteRole';
// =============== Column permissions related end =======================
// ================ mirror related start =======================
exports.READ_MIRROR_INFO = 'mirror/:mirrorId/info'; // Request mirror data
exports.READ_MIRROR_DATA_PACK = 'mirror/:mirrorId/dataPack'; // Request the data of the mirror-related table
exports.READ_SHARE_MIRROR_INFO = 'share/:shareId/mirror/:mirrorId/info'; // Request the data of mirror-related tables
exports.READ_SHARE_MIRROR_DATA_PACK = 'share/:shareId/mirror/:mirrorId/dataPack'; // Request the data of the mirror-related table
exports.GET_MIRROR_SUBSCRIPTIONS = '/mirrors/:mirrorId/records/subscriptions'; // Get the concerned record IDs of the mirror table
exports.SUBSCRIBE_MIRROR_RECORDS = '/mirrors/:mirrorNodeId/records/subscriptions'; // Pay attention to the data in the mirror table
exports.UNSUBSCRIBE_MIRROR_RECORDS = '/mirrors/:mirrorNodeId/records/subscriptions'; // Unfollow the data in the mirror table
// =============== mirror related end =======================
// ================ View switch related start =======================
exports.GET_DST_VIEW_DATA_PACK = 'datasheet/:dstId/view/:viewId/dataPack';
exports.GET_SHARE_DST_VIEW_DATA_PACK = 'share/:shareId/datasheet/:dstId/view/:viewId/dataPack';
// =============== View switch related end =======================
// =============== datasheet related =======================
// ================ form ================
// load form data
exports.FORMPACK = '/form/:formId/dataPack';
// Get form share page data
exports.READ_SHARE_FORMPACK = '/share/:shareId/form/:formId/dataPack';
// Get form template page data
exports.READ_TEMPLATE_FORMPACK = '/template/:templateId/form/:formId/dataPack';
// Form submission data in the space station
exports.FORM_ADD_RECORD = '/form/:formId/addRecord';
// form share page submit data
exports.SHARE_FORM_ADD_RECORD = '/share/:shareId/form/:formId/addRecord';
// Update form related properties in the space station
exports.UPDATE_FORM_PROPS = '/form/:formId/props';
// Get all the properties of the form in the space station
exports.READ_FORM_PROPS = '/form/:formId/props';
// Update form related properties in the space station
exports.READ_FORM_SUBMIT_STATUS = '/form/:formId/submitStatus';
// =============== Magic form related ===============
// =============== Socket =======================
// datasheet long link
exports.WEBSOCKET_NAMESPACE = '/room';
// datasheet - collaborative operation long link
exports.ROOM_PATH = '/room';
// message notification long link
exports.NOTIFICATION_PATH = '/notification';
// =============== Socket related =======================
exports.GET_COMMENTS_BY_IDS = 'datasheet/:dstId/record/:recordId/comments';
exports.APPLY_RESOURCE_CHANGESETS = 'resource/apply/changesets';
// =============== Resource related =======================
// Get a list of resource-specific changesets
exports.READ_CHANGESET = '/resource/:resourceId/changesets';
exports.READ_SHARE_CHANGESET = '/shares/:shareId/resources/:resourceId/changesets';
// Get the associated table data of the resource
exports.READ_FOREIGN_DATASHEET_PACK = '/resource/:resourceId/foreignDatasheet/:foreignDatasheetId/dataPack';
// Get the associated table data of the resource
exports.READ_FOREIGN_DATASHEET_VIEW_PACK = '/resource/:resourceId/foreignDatasheet/:foreignDatasheetId/:viewId/dataPack';
// Get the associated table data of the shared resource
exports.READ_SHARE_FOREIGN_DATASHEET_PACK = '/share/:shareId/resource/:resourceId/foreignDatasheet/:foreignDatasheetId/dataPack';
// Get comments and history for a single record
exports.GET_RECORD_ACTIVITY_LIST = '/resources/:resourceId/records/:recId/activity';
exports.READ_EMBED_FOREIGN_DATASHEET_PACK = 'embedlinks/:embedId/resources/:resourceId/foreignDatasheets/:foreignDatasheetId/dataPack';
// =============== datasheet related =======================
// load table data package
exports.DATAPACK = '/datasheet/:dstId/dataPack';
// Get the list of specified records in the datasheet
exports.READ_RECORDS = '/datasheet/:dstId/records';
// Get the form data of the share page
exports.READ_SHARE_DATAPACK = '/share/:shareId/datasheet/:dstId/dataPack';
// template packet
exports.READ_TEMPLATE_DATAPACK = '/template/datasheet/:dstId/dataPack';
// Get the form  Data of the embed page
exports.READ_EMBED_DATAPACK = '/embedlinks/:embedId/resources/:dstId/dataPack';
// get user list
exports.GET_USER_LIST = '/datasheet/:nodeId/users';
// Get the Meta corresponding to the datasheet
exports.READ_DATASHEET_META = '/datasheet/:dstId/meta';
exports.GET_DATASHEET_SUBSCRIPTIONS = '/datasheets/:dstId/records/subscriptions'; // Get the concerned record IDs of the datasheet GET
exports.SUBSCRIBE_DATASHEET_RECORDS = '/datasheets/:dstId/records/subscriptions'; // Follow the data in the datasheet POST
exports.UNSUBSCRIBE_DATASHEET_RECORDS = '/datasheets/:dstId/records/subscriptions'; // Unfollow the data in the datasheets
// =============== datasheet related =======================
exports.GET_CONTENT_DISPOSITION = '/attach/getContentDisposition';
// Cascader data
exports.CASCADER_DATA = '/spaces/:spaceId/datasheets/:datasheetId/cascader';
// Get cascader snapshot data
exports.CASCADER_SNAPSHOT = '/datasheets/:datasheetId/fields/:fieldId/cascader-snapshot';
// Update cascader snapshot data
exports.UPDATE_CASCADER_SNAPSHOT = '/spaces/:spaceId/datasheets/:datasheetId/fields/:fieldId/cascader-snapshot';
//# sourceMappingURL=url.data.js.map